import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiAccountMultiple } from '@lumapps/lumx/icons';
import { useSelector } from '@lumapps/redux/react';
import { canAccessSegmentAdmin } from '@lumapps/segment/ducks/slice/selectors';
import { useTranslate } from '@lumapps/translations';

import { SEGMENT_ADMIN } from '../../keys';
import { segmentBaseRoute } from '../../routes';

export const SegmentSideNavigation: React.FC<Partial<SideNavigationItemProps>> = (props) => {
    const { translateKey } = useTranslate();
    const isAllowed = useSelector(canAccessSegmentAdmin);

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...props}
            icon={mdiAccountMultiple}
            label={translateKey(SEGMENT_ADMIN.SEGMENT_SIDE_NAV_TITLE)}
            route={segmentBaseRoute}
        />
    );
};

SegmentSideNavigation.displayName = 'SideNavigationItem';
